const weekdays = [
    "So",
    "Mo",
    "Di",
    "Mi",
    "Do",
    "Fr",
    "Sa"
]

function getFormatedDate(date, translation, flyerDate=false) {
    const dateObj = date
    const day = weekdays[dateObj.getDay()]
    const dayInteger = dateObj.getDate()
    const monthInteger = parseInt(dateObj.getMonth() + 1 )

    if(flyerDate) {
        return day
    } else {
        return  day + ', ' + dayInteger + '.' + monthInteger + '.'
    }
}

export default getFormatedDate